import styled from 'styled-components'
import { smStyle } from '@/components/Adapter'

export const PriceLearnStyled = styled.div`
  display: flex;
  flex-direction: column;
`
export const GateLearnItemStyled = styled.li`
  list-style: none;
  padding: 24px 0;
  cursor: pointer;

  .price-learn-item--image {
    object-fit: cover;
  }

  &[data-border='true'] {
    border-bottom: 1px solid var(--color-divider-2);
  }
`

export const PriceLearnTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 20px;

  ${smStyle} {
    font-size: 24px;
  }
`
export const PriceLearnTagStyled = styled.div`
  max-width: calc(100% - 80px);
  overflow-x: scroll;

  &::-webkit-scrollbar {
    display: none; /* 不显示滚动条 */
  }
  /* 兼容写写法 */
  scrollbar-width: none; /* 隐藏滚动条 */
  scrollbar-color: transparent transparent; /* 设置滚动条颜色为透明 */
`
